// import { defaultColors } from './colors/default';

export const baseTheme = {
  colors: {

    white: '#fff',
    green: '#4b8b3b',
    red: '#ff0000',
    yellow: '#ffeb00',
    blue: '#004eff',
    orange: '#F7A729',
    mediumOrange: '#f59c27',
    textGray: '#cfcfcf',
    textGrayAlt: '#a9a9a9',
    lightGray: '#444',
    mediumGray: '#363636',
    mediumDarkGray: '#2C2C2C',
    FAQGray: '#262626',
    carouselDark: '#1D1D1D',
    darkGray: '#161616',
    button: 'linear-gradient(-90deg,#eb7227 0,#f18d22 50%,#f7a729 100%)'


    // ...defaultColors,
  },
  fonts: {
    light: 'UOLTextLight, Arial, Helvetica, sans-serif',
    regular: 'UOLText, Arial, Helvetica, sans-serif',
    bold: 'UOLTextBold, Arial, Helvetica, sans-serif',
  },
  sizes: {
    1: '2px',
    2: '4px',
    4: '8px',
    5: '10px',
    6: '12px',
    7: '14px',
    8: '16px',
    9: '20px',
    10: '24px',
    12: '32px',
    13: '40px',
    14: '48px',
    15: '56px',
    16: '64px',
    17: '72px',
    18: '80px',

    buttonMenu: '217px',
    buttonMenuHeight: '47px',

    buttonWidth: '186px',
    buttonHeight: '60px',
    buttonNavbarHeight: '48px'
  },
  space: {
    xxs: '4px',
    xs: '8px',
    sm: '12px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    xxl: '40px',
    xxxl: '48px',
    giant: '64px',
    huge: '80px',
    base: '$md',
  },
  fontSizes: {
    xs: '12px',
    sm: '14px',
    base: '16px',
    md: '16px',
    lg: '18px',
    xl: '20px',
    xl2: '24px',
    xl3: '30px',
    xl4: '36px',
    xl5: '40px',
    xl6: '48px',
    xl7: '60px',
    xl8: '72px',
    xl9: '96px',
    xl10: '128px'
  },
  fontWeights: {
    hairline: 100,
    thin: 200,
    light: 300,
    normal: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
    extrabold: 800,
    black: 900
  },
  letterSpacings: {
    tighter: '-0.05rem',
    tight: '-0.025rem',
    normal: '-0.125rem',
    wide: '0.025rem',
    wider: '0.05rem',
    widest: '0.1rem'
  },
  lineHeights: {
    xs: 1,
    sm: 1.25,
    base: 1.4,
    md: 1.5,
    lg: 1.75,
    xl: 1.75,
    xl2: 2,
    xl3: 2.25,
    xl4: 2.5,
    xl5: 1,
    xl6: 1,
    xl7: 1,
    xl8: 1,
    xl9: 1
  },
  borderWidths: {
    1: '1px',
    2: '2px',
    3: '4px',
    4: '8px',
    hairline: '$1',
    thin: '$2',
    thick: '$3',
    heavy: '$4'
  },
  radii: {
    none: '0',
    xs: '4px',
    sm: '8px',
    md: '16px',
    lg: '24px',
    pill: '500px',
    circular: '50%',
    base: '$sm',
  },
  zIndices: {
    high: 40,
    highest: 100
  },
  transitions: {
    basic: 'all cubic-bezier(0.4, 0, 0.2, 1) 150ms',
    button: 'all ease-in 300ms'
  }
}
